<template>
  <div
    class="bg-base-200 rounded-xl p-3 flex items-center gap-3 justify-between"
    :key="memory.id"
  >
    <div>
      <div class="flex items-center gap-2 mb-1">
        <MateMemoryDot :color="memory.labelColor" />
        <div class="font-bold">{{ memory.name }}</div>
      </div>
      <div>
        <div class="text-base-content/60">
          <span :class="`rarity-${memory.capacityLevel}`">
            {{ $t(`memory.ball.${memory.capacityLevel}`) }}
          </span>
          <br />字数：{{ memory.text?.length }}/{{
            MemoryCapacityLevelMap[memory.type]?.[memory.capacityLevel] ?? 0
          }}<br />最后更新时间:{{ timeAgo(memory.dtUpdate) }}
        </div>
      </div>
    </div>
    <div class="flex items-center gap-2 flex-col">
      <div
        v-if="memory.extractionStatus === MemoryExtractionStatus.Extracting"
        class="text-warning"
      >
        正在提取至记忆球
      </div>
      <template v-else-if="!isSelect">
        <button class="btn btn-xs btn-outline" @click="handleEditMemory">
          编辑
        </button>
        <template v-if="memory.type === MemoryType.Core">
          <button
            v-if="memory.slot"
            class="btn btn-xs btn-outline btn-error"
            @click="handleUnloadMemory"
          >
            卸载
          </button>
          <button
            v-else
            class="btn btn-xs btn-outline btn-success"
            @click="handleLoadMemory"
          >
            加载
          </button>
        </template>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { loadOneMateMemory, unloadOneMateMemorySlot } from "@/apis/mate";
import {
  MemoryCapacityLevelMap,
  MemoryExtractionStatus,
  MemoryType,
} from "@/enums/mateEnums";
import { timeAgo } from "@/modules/common";
import { sessionStorageSet } from "@/tools/sessionStorage";
import { MateMemory } from "@/types/entity";
import { useRouter } from "vue-router";

const props = defineProps<{
  memory: MateMemory;
  isSelect?: boolean;
}>();

const router = useRouter();

const emit = defineEmits<{
  (e: "reload"): void;
}>();

const handleLoadMemory = async () => {
  await loadOneMateMemory(props.memory.id);
  emit("reload");
};

const handleEditMemory = () => {
  const memory = props.memory;
  sessionStorageSet("memory:edit:" + memory.id, memory);

  router.push({
    name: "mateMemoryEdit",
    query: {
      memoryId: memory.id,
    },
  });
};

const handleUnloadMemory = async () => {
  await unloadOneMateMemorySlot(props.memory.slot!.id);
  emit("reload");
};
</script>
